<template>
  <div class="introduce">
    <div class="bigImg"></div>
    <div class="box">
      <img src="../../static/introduce/ldj.jpg" alt="">
      <img src="../../static/introduce/ldy.jpg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name:'introduce',
  created(){
    // 传参控制显示顶部和底部(与其它页面保持一致，直接进入本页时也能显示头部导航)
    this.$emit('controlShow', false);
  }
}
</script>

<style lang="less" scoped>
  .introduce{
    width: 100%;
    .bigImg{
      width: 100%;
      height: 500px;
      background: url('../../static/introduce/banner.jpg') no-repeat;
      background-size: cover;
    }
    .box{
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      padding: 50px 0;
      img{
        margin: 30px auto;
      }
    }
  }

  /* ---------------- wap端(≤768px) ---------------- */
  @media screen and (max-width: 768px) {
    .introduce{
      .bigImg{
        width: 100%;
        height: 0;
        // 750 * 920 的wap专用banner
        padding-top: 122.66%;
        background: url('../../static/index/wapImg/productBanner.jpg') no-repeat;
        background-size: 100% 100%;
      }
      .box{
        padding: 20px 0;
        img{
          width: 96%;
          height: auto;
          margin: 10px auto;
        }
      }
    }
  }
</style>